export const EDUCATION_LEAD = 'Целью программы является формирование у московских предпринимателей системных знаний и практических навыков для эффективного вывода бизнеса на международные рынки и успешного ведения внешнеэкономической деятельности.';

export const EDUCATION_SCOPE = 'Программа ориентирована на комплексное освоение всех ключевых аспектов ВЭД: от стратегического анализа рынков до практических вопросов заключения контрактов, логистики, таможенного и налогового регулирования.';

export const EDUCATION_FORMATS_TITLE = 'Форматы:';

export const EDUCATION_FORMATS = [
  'обучающие программы в партнерстве с российскими ВУЗами',
  'экспортно ориентированные вебинары «Час с Торгпредом»',
  'семинары, бизнес-диалоги и мастер-классы с профильными экспертами в сфере ВЭД',
];
